import React, { useEffect } from 'react';
import CardTileA from '../Common/CardTileA';
import { useBalance } from '../../DataStore/BalanceContext';
import IncomExpenseChart from './IncomExpenseChart';
import functions from '../../util/functions';

const BalanceSheetSummary = () => {

    const {
        incomeBalance,
        expenseBalance,
        assetBalance,
        liabilityBalance,
        getIncomeBalance,
        getExpenseBalance,
        getAssetBalance,
        getLiabilityBalance
    } = useBalance();

    useEffect(()=>{
        getIncomeBalance();
        getExpenseBalance();
        getAssetBalance();
        getLiabilityBalance();
    }, [])


    return (
        <>
            <div className="col-md-12 col-lg-6">
                 <div className="card">
                    <div className='card-body'>
                        <IncomExpenseChart totalExpenses={expenseBalance} totalIncome={incomeBalance} />
                    </div>
                </div> 

            </div>
            <div className="col-md-12 col-lg-6">
                    <CardTileA 
                        title="Assets" 
                        value={ functions.numberFormat(assetBalance)} 
                        cardIcon="far fa-hourglass"
                        cardIconClass="text-primary"
                        preText="Ugx"
                        borderColorClass={'primary'}
                    />

                    <CardTileA 
                        title="Liabilities" 
                        value={functions.numberFormat(liabilityBalance)} 
                        cardIcon="fa fa-briefcase"
                        cardIconClass="text-warning"
                        preText="Ugx"
                        borderColorClass={'warning'}
                    />

            </div>
        </>
    );
};

export default BalanceSheetSummary;